import React from 'react';

import { Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';

import { IServiceOption } from '../../../../../interfaces/reviews';
import { ISpecificProducts } from '../../../../../store/reducers/filters';
import styles from '../products-modal.module.scss';

import { ProductButton } from './Button';
import { IProductsListProps } from './List';

interface IProductLinkProps
  extends Pick<IProductsListProps, 'currentService' | 'getTagLink' | 'isServicePage' | 'handleSetService'> {
  product: IServiceOption;
  products: {
    [key: string]: ISpecificProducts[];
  };
}

export const ProductLink = ({
  currentService,
  getTagLink,
  isServicePage,
  handleSetService,
  product,
  products,
}: IProductLinkProps) => {
  const hasProducts = products?.[product.value]?.length > 0;
  const { as } = getTagLink(currentService || product, currentService && product.id);
  const nowrapButton = !currentService && !isServicePage;

  return hasProducts ? (
    <div className={styles.serviceLink} onClick={() => handleSetService(product)}>
      <ProductButton product={product} nowrap={nowrapButton} />
      <Icon icon={<ArrowRight />} />
    </div>
  ) : (
    <a className={styles.serviceLink} href={as}>
      <ProductButton product={product} nowrap={nowrapButton} />
    </a>
  );
};
